export function clearHistoryState(): void {
    window.history.replaceState({...window.history.state, usr: null}, '');
}
